import React, { useState, useEffect } from 'react';
import { Button, Container, Grid, TextField } from '@material-ui/core';
import { getBacchusURL, handleError, isAdmin, remainingTime } from '../shared/Functions';
import { authProvider } from '../../services/Security';
import { Autocomplete } from '@material-ui/lab';
import { DistrictsVService, OperatorsVService } from '../../services/V2/padre';
import { BillingAccountsVService } from '../../services/V2/gozer';
import { AutocompleteWithPaging } from '../shared/AutocompleteWithPaging';

export const BillArchive = (props) => {
    const [operators, setOperators] = useState<any[]>([]);
    const [operator, setOperator] = useState<any>();
    const [districts, setDistricts] = useState<any[]>([]);
    const [district, setDistrict] = useState<any>();
    const [billingAccount, setBillingAccount] = useState<any>();
    const [billingAccounts, setBillingAccounts] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    const [canReadOperators, setCanReadOperators] = useState<boolean>(false);
    const [canReadDistricts, setCanReadDistricts] = useState<boolean>(false);
    const [canReadBillingAccounts, setCanReadBillingAccounts] = useState<boolean>(false);
    const [model, setModel] = useState<any>();
    const [resetToken, setResetToken] = useState<boolean>(false);
    const [accountNumber, setAccountNumber] = useState<string>("");
    const url = getBacchusURL()

    const loadIframe = () => {
        authProvider.getNexusTokenFull().then(token => {
            setTimeout(() => setResetToken(!resetToken), remainingTime(token.tokenExpires))
            const frame = document.getElementById('bill-archive') as HTMLIFrameElement;
            frame?.contentWindow?.postMessage(JSON.stringify({
                token: token,
                billingAccountId: billingAccount?.id
            }), url);
        })
    }

    useEffect(() => {
        authProvider.getNexusToken().then(token => {
            let perms = authProvider.getPermissions(token);
            setCanReadOperators(perms.some((perm: string) => perm === "ReadOperator"));
            setCanReadDistricts(perms.some((perm: string) => perm === "ReadDistrict"));
            setCanReadBillingAccounts(perms.some((perm: string) => perm === "ReadBillingAccounts"));
        })
    }, [])

    useEffect(() => {
        if(operators.length > 0) return;
        let operatorId = authProvider.getUser()?.OperatorId;
        if(!operatorId && canReadOperators){
            OperatorsVService.operatorsVGetAll({
                    pageNumber: 1,
                    orderBy: "Name",
                    orderByDesc: false
                })
                .then(o => {
                    setOperators(o.items ?? [])
                })
                .catch(err => handleError(err));
        } else if(operatorId && canReadOperators){
            OperatorsVService.operatorsVGetById(operatorId)
                .then(o => {
                    setOperator(o);
                })
                .catch(err => handleError(err));
        }
    }, [operators, canReadOperators])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if(operator && canReadDistricts){
            DistrictsVService.districtsVGetAllAnon(operator.id, true)
                .then(d => setDistricts(d))
                .catch(err => handleError(err));
        }
    }, [operator, canReadDistricts])// eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {
        if(district && canReadBillingAccounts){
            setModel({
                pageNumber: 1,
                numberPerPage: 15,
                filters: [{
                    property: "DistrictId",
                    value: district?.id
                }],
                orderBy: "AccountNumber",
                orderByDesc: false
            })
        }
    }, [district, canReadBillingAccounts])// eslint-disable-line react-hooks/exhaustive-deps

    const searchForAccountNumber = (searchValue) => {
        if (searchValue) {
            setModel(
                {
                    ...model,
                    filters: [
                        {
                            property: "AccountNumber",
                            value: searchValue
                        },
                        {
                            property: "DistrictId",
                            value: district?.id
                        }
                    ]
                }
            )
        }
        else {
            setModel(
                {
                    ...model,
                    filters: [
                        {
                            property: "DistrictId",
                            value: district?.id
                        }
                    ],
                }
            )
        }
    }

    return (
        <React.Fragment>
            <Container maxWidth="xl">
                <div style={{backgroundColor: "white", borderRadius: "10px"}}>
                    <div style={{padding: '15px', margin:'0px'}}>
                        <h6 style={{textAlign: "left", fontSize:"1.25rem", letterSpacing:"0.0075em", lineHeight:"1.6"}}>Billing Account Archive Bill</h6>
                            <div className="row col-12">
                                {operators &&
                                    <Grid item xs={2}
                                        container={true}
                                        alignContent="flex-start">
                                        <Autocomplete
                                            value={operator || {}}
                                            id="operator"
                                            options={operators}
                                            getOptionLabel={(option) => option?.name ?? ""}
                                            renderOption={(option, { selected }) => (
                                                <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                            )}
                                            style={{ width: "100%", paddingRight: "10px", color: "#fff", textAlign:"center" }}
                                            renderInput={(params) => <TextField style={{textAlign:"center"}} {...params} label="Operator" variant="outlined" />}
                                            getOptionSelected={(o, v) => o.id === v.id}
                                            onChange={(e, o) => {
                                                    if(!operator) {
                                                        setDistrict(null);
                                                        setDistricts([]);
                                                    }
                                                    setOperator(o);
                                                }}
                                            />
                                    </Grid>
                                }
                                {operator && districts &&
                                    <Grid item xs={2}
                                        container={true}
                                        alignContent="flex-start">
                                        <Autocomplete
                                            value={district || {}}
                                            id="district"
                                            options={districts}
                                            getOptionLabel={(option) => option?.name ?? ""}
                                            renderOption={(option, { selected }) => (
                                                <div style={{ width: "100%", textAlign:"center" }}>{option?.name}</div>
                                            )}
                                            style={{ width: "100%", paddingRight: "10px" }}
                                            renderInput={(params) => <TextField {...params} label="District" variant="outlined" required={isAdmin()} />}
                                            getOptionSelected={(o, v) => o.id === v.id}
                                            onChange={(e, d) => {
                                                    setDistrict(d);
                                                }}
                                            />
                                    </Grid>
                                }
                                {district && billingAccounts &&
                                    <>
                                        <AutocompleteWithPaging 
                                            fetchSuggestions={BillingAccountsVService.billingAccountsVGetAll} 
                                            model={model}
                                            setModel={setModel}
                                            inputValue={billingAccount}
                                            setInputValue={setBillingAccount}
                                            suggestions={billingAccounts}
                                            setSuggestions={setBillingAccounts}
                                            label={"Billing Accounts"}
                                            loading={loading}
                                            setLoading={setLoading} />

                                        <Grid item xs={3}
                                            container={true}
                                            alignContent="flex-start"
                                            style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                                            <TextField
                                                onChange={event => setAccountNumber(event?.target?.value)}
                                                required={false}
                                                name="accountNumber"
                                                label="Search Account Number"
                                                type="text"
                                                value={accountNumber}
                                                variant="outlined"
                                            />
                                            <Button
                                                disabled={loading}
                                                style={{ marginLeft: "auto", marginRight: "auto" }} 
                                                onClick={() => searchForAccountNumber(accountNumber)}>
                                                    {accountNumber !== "" ? "Search" : "Search All"}
                                            </Button>
                                        </Grid>
                                    </>
                                }
                            </div>
                            <div className="row col-12" style={{ paddingLeft: '15px', paddingBottom: '15px', margin:'0px' }}>
                                <Button onClick={loadIframe} color="primary">
                                    View Bills
                                </Button>
                            </div>
                    </div>
                    <iframe id="bill-archive"
                        title="bill-archive"
                        src={`${url}/#/app/bill-archive`}
                        width="1600px"
                        height="600px" />
                </div>
            </Container>
        </React.Fragment>
    );
}